import * as types from "../constants/actionTypes";
import * as msgs from "../constants/textConstants";
import * as patientIDs from "../constants/PatientIDTypes";

import { v4 as uuidv4 } from 'uuid';
import * as Tools from "../helpers/Tools";

const convert = function (value) {
    if (typeof value === 'string') {
        const stringValue = value.toLowerCase();
        if (stringValue === 'true') value = true;
        else if (stringValue === 'false') value = false;
    }
    return value;
}

export const sessionInitialState = function () {
    return {
        terms: null,
        userHasAccepted: false,
        reloadKey: uuidv4(),
        hideTutorialPrompt: true,
        showAutoHPLinkModal: false,
        showInsuranceForm: false,
        showAutoLinkMyChart: false,
        showVideoVisitToolTip: false,
        healthPlanUserProfile: null,
        healthPlanUserToken: null,
        currentHealthPlanInfo: null,
        hasSWHP: false,
        hasAAL: false,
        networkCode: null,
        insuranceName: null,
        healthPlans: null,
        hpId: null, //Health Plan Id
        aaId: null, //AA Id
        fcId: null, //First Care Id
        hasFirstCare: false, // This value needs to be mapped from GetHealthPlans Call. After 9/1 will remove reference from domain reducer. 
        hasADental: false,
        useOnboardingLayout: false,
        loginNotice: window.data && window.data.serverData ? window.data.serverData.loginNotice : null,
        headerMessage: window.data && window.data.serverData ? window.data.serverData.headerMessage : null,
        masterSpinnerOn: false,
        hasSeenScheduleCareTooltip: false,
        newProxySuggestionList: null,
        selectedProxySuggestionUsers: [],
        profileDataLoaded: false
    };
};

export default function sessionReducer(state = sessionInitialState(), action) {
    switch (action.type) {
        case types.INIT_SESSION:
            // TODO: use with asp-prerender-data to set initial state from the server.
            return state;
        case types.PROFILE_DATA_LOADED:
            return { ...state, profileDataLoaded: true };
        case types.SET_SERVER_DATA:
            return { ...state, serverData: action.serverData };
        case types.SET_HISTORY_OBJECT:
            return { ...state, history: action.history };
        case types.SET_TERMS_AND_CONDITIONS:
            return { ...state, terms: action.terms || state.terms, version: action.version || state.version, userHasAccepted: action.HasAccepted || state.userHasAccepted };
        case types.LOGOUT:
            return {
                ...state,
                userHasAccepted: false,
                healthPlanUserProfile: null,
                healthPlanUserToken: null,
                profileDataLoaded: false,
            };
        case types.LOGOUT_COMPLETED:
            return {
                ...state,
                currentHealthPlanInfo: null,
                hasSWHP: false,
                hasAAL: false,
                hasFirstCare: false,
                insuranceName: null,
                networkCode: null,
                healthPlans: null,
                hpId: null,
                aaId: null,
                fcId: null,
                profileDataLoaded: false,
                selectedProxySuggestionUsers: [], hasSelectedProxySuggestionUsers: false, newProxySuggestionList: [], hasProxySuggestions: false
            };
        case types.SET_USER_PREFERENCES:
            const userPreferences = {};
            if (action.userPreferences && action.userPreferences.length > 0) {
                action.userPreferences.forEach(p => {
                    let value = convert(p.PreferenceValue);
                    userPreferences[p.PreferenceName] = value;
                });
            }
            return { ...state, userPreferences };
        case types.GET_USER_PREFERENCE_SUCCESS:
        case types.UPDATE_USER_PREFERENCE_SUCCESS:
            if (!state.userPreferences) {
                state.userPreferences = {};
            }
            state.userPreferences[action.PreferenceName] = convert(action.PreferenceValue);
            return state;
        case types.GET_USER_PREFERENCE_FAILURE:
        case types.UPDATE_USER_PREFERENCE_FAILURE:
            if (!state.userPreferences) {
                state.userPreferences = {};
            }
            state.userPreferences[action.PreferenceName] = null;
            return state;
        case types.SET_HIDE_TUTORIAL:
            return { ...state, hideTutorialPrompt: action.hideTutorialPrompt };
        case types.SET_HIDE_AUTO_HP_LINKMODAL:
            return { ...state, showAutoHPLinkModal: action.showAutoHPLinkModal };
        case types.SHOW_INSURANCE_FORM:
            return { ...state, showInsuranceForm: action.showInsuranceForm };
        case types.SHOW_ADD_DEPENDENT_PROXY_FORM:
            return { ...state, showDependentProxyForm: action.showDependentProxyForm };
        case types.SHOW_AUTOLINK_MYCHART:
            return { ...state, showAutoLinkMyChart: action.showAutoLinkMyChart };
        case types.SHOW_VIDEO_VISIT_TOOLTIP:
            return { ...state, showVideoVisitToolTip: action.showVideoVisitToolTip };
        case types.SAVE_PROXY_REQUESTEE_INFO:
            return { ...state, proxyRequesteeInfo: action.proxyRequesteeInfo };
        case types.RELOAD_KEY:
            return { ...state, reloadKey: uuidv4() };
        case types.HP_USERDATA_SUCCESS:
            return { ...state, healthPlanUserProfile: action.hpUserIdentity };
        //case types.HP_USERDATA_STORETOKEN:
        //    return { ...state, healthPlanUserToken: action.token };
        case types.SHOW_GET_CARE_TOOLTIP:
            return { ...state, showGetCareToolTip: action.showGetCareToolTip };
        case types.SHOW_FAMILY_MANAGEMENT_TOOLTIP:
            return { ...state, showFamilyManagementToolTip: action.showFamilyManagementToolTip, hasRedirect: action.hasRedirect };
        //case types.SHOW_DCJ_SELF_ENROLL_TOOLTIP:
        //    return { ...state, showDCJSelfEnrollToolTip: action.showDCJSelfEnrollToolTip };
        case types.SHOW_MARKETING_EMAIL_OPT_IN:
            return { ...state, showEmailOptIn: action.showEmailOptIn };
        case types.SHOW_FAMILYMEMBERS_SCREEN:
            return { ...state, showFamilyMembersScreen: action.showFamilyMembersScreen };
        case types.SHOW_ONBOARDING_MODAL:
            return { ...state, showOnboardingModal: action.showOnboardingModal };
        case types.SHOW_NOTIFICATIONS_SCREEN:
            return { ...state, showNotificationsScreen: action.showNotificationsScreen };
        case types.SHOW_SCHEDULE_CARE_TOOLTIP:
            return { ...state, showScheduleCareTooltip: action.showScheduleCareTooltip };
        case types.HAS_COMPLETED_ONBOARDING:
            return { ...state, hasCompletedOnboarding: action.hasCompletedOnboarding };
        case types.SET_USE_ONBOARDING_LAYOUT:
            return { ...state, useOnboardingLayout: action.useOnboardingLayout };
        //case types.CARECOACH_JOURNEY_PREFERENCE:
        //    return { ...state, noActiveDCJEids: action.noActiveDCJEids };

        case types.SET_HEALTHPLAN_INFO:
            //As discussed added healthplan roles in session reducer, after 9/1 will remove from domain reducer references.
            const loginProvider = action.healthPlanInfo && action.healthPlanInfo.LoginProvider ?
                action.healthPlanInfo.LoginProvider.toLowerCase() : '';
            const insuranceName = action.healthPlanInfo && action.healthPlanInfo.FullName ?
                action.healthPlanInfo.FullName : '';
            const networkCode = action.healthPlanInfo && action.healthPlanInfo.NetworkCode ?
                action.healthPlanInfo.NetworkCode : null;
            const providerKey = action.healthPlanInfo && action.healthPlanInfo.ProviderKey ?
                action.healthPlanInfo.ProviderKey : null;
            const hasSWHP = loginProvider === msgs.LOGIN_PROVIDER_SWHP || loginProvider === msgs.LOGIN_PROVIDER_HR_SWHP;
            const hasAAL = loginProvider === msgs.LOGIN_PROVIDER_AAL;
            const hasFirstCare = loginProvider === msgs.LOGIN_PROVIDER_FIRSTCARE;
            const hpId = hasSWHP ? providerKey : null;
            const aaId = hasAAL ? providerKey : null;
            const fcId = hasFirstCare ? providerKey : null;
            return {
                ...state,
                currentHealthPlanInfo: action.healthPlanInfo,
                hasSWHP: hasSWHP,
                hasAAL: hasAAL,
                hpId: hpId,
                aaId: aaId,
                fcId: fcId,
                hasFirstCare: hasFirstCare,
                insuranceName: insuranceName,
                networkCode: networkCode,
                healthPlans: action.healthPlans,
                hasADental: action.hasADental,
                //maintenanceEvents: action.maintenanceEvents,
            };

        case types.SET_HEALTHPLAN_MAINTENANCE_EVENTS:
            return {
                ...state,
                maintenanceEvents: action.maintenanceEvents,
            };

        // we add this here because some values where pulling from Session.ServerData
        // which is only loaded once at startup.  We want the banner bar at the top to show
        // and hide as values are changed on the server, so we overwrite the corresponding serverdata
        case types.GOT_APP_UPDATE:
            if (action.success) {
                //debugger;
                return {
                    ...state, serverData: {
                        ...state.serverData,
                        "rxDown": action.data.rxDown,
                        "aalDown": action.data.aalDown,
                        "swhpDown": action.data.swhpDown,
                        "epicEHRDown": action.data.epicEHRDown,
                        "siteOutage": action.data.siteoutage,
                        "loginNotice": action.data.loginNotice,
                        "headerMessage": action.data.headerMessage,
                    }
                };

            }
            else {
                return { ...state };
            }
        case types.SHOW_CARE_COACH_MODAL:
            return {
                ...state, showCareCoachModal: action.showCareCoachModal
            };
        case types.MASTER_SPINNER_ON:
            return {
                ...state,
                masterSpinnerOn: true
            };
        case types.MASTER_SPINNER_OFF:
            return {
                ...state,
                masterSpinnerOn: false
            };
        case types.SHOW_THRIVE_TOOLTIP:
            return {
                ...state, showThriveTooltip: action.showThriveTooltip
            };
        case types.HAS_SEEN_SCHEDULE_CARE_TOOLTIP:
            return {
                ...state, hasSeenScheduleCareTooltip: action.hasSeenScheduleCareTooltip
            }
        case types.GET_PROXY_SUGGESTION_LIST:
            let hasProxySuggestions = false;
            let proxySuggestionUsers = [];
            if (action.payload && action.payload.success) {
                proxySuggestionUsers = action.payload?.data?.proxySuggestions;
                hasProxySuggestions = proxySuggestionUsers?.length > 0 || action.payload?.data?.hasProxySuggestions ? true : false;

                if (hasProxySuggestions) {
                    //Add new properties to each user in this list, i.e. id, isChecked, isCompleted, hasError, errorMessage
                    proxySuggestionUsers = proxySuggestionUsers.map((user, index) => {
                        return { ...user, id: uuidv4(), isChecked: false, isCompleted: false, hasError: false, errorMessage: null };
                    })
                }

            }
            return {
                ...state, newProxySuggestionList: proxySuggestionUsers, hasProxySuggestions: hasProxySuggestions
            }

        case types.SET_PROXY_SELECTED_USERS:
            let hasSelectedProxySuggestionUsers = action.selectedProxySuggestionUsers?.length > 0;
            return {
                ...state, selectedProxySuggestionUsers: action.selectedProxySuggestionUsers, hasSelectedProxySuggestionUsers
            }
        case types.CLEAR_PROXY_SELECTED_USERS:
            return {
                ...state, selectedProxySuggestionUsers: [], hasSelectedProxySuggestionUsers: false, newProxySuggestionList: [], hasProxySuggestions: false
            }

        default:
            return { ...state };
    }
}



    //rxDown: action.data.rxDown,
    //    aalDown: action.data.aalDown,
    //        swhpDown: action.data.swhpDown,
    //            epicEHRDown: action.data.epicEHRDown,
    //                appVersion: action.data.appVersion,
    //                    minAppVersion: action.data.minappversion,
    //                        siteOutage: action.data.siteoutage,



            //bool rxDown = Model.UseSystemValues ? Model.SystemValues.RXIsDown.Value : SharedTools.Tools.GetConfigBool("RxDown", false, false);
            //bool aalDown = Model.UseSystemValues ? Model.SystemValues.AALIsDown.Value : SharedTools.Tools.GetConfigBool("AALDown", false, false);
            //bool swhpDown = Model.UseSystemValues ? Model.SystemValues.SWHPIsDown.Value : SharedTools.Tools.GetConfigBool("SWHPDown", false, false);
            //bool epicEHRDown 